import { IIAMEntity } from "./iam-entity"

export interface IIAMUser extends IIAMEntity{
    UserName: string
    UserId: string
    PasswordLastUsed?: string
    Tags?: Array<{Key: string, Value: string}>
}

export interface IIAMUserRequest{
    UserName: string
}

export interface IIAMUserUpdateRequest extends IIAMUserRequest {
    NewUserName: string
}

export interface IIAMUserPolicyRequest extends IIAMUserRequest {
    PolicyArn: string
}

export enum IAMUserSortField {
    UserName = "UserName",
    ARN = "Arn",
    CreateDate = "CreateDate",
    LastUsed = "PasswordLastUsed",
}
